import { initScratchcard } from './global/scratchcard';
import { getPrize, setPrizeWinLoseHtml } from './global/getPrize';
import runTextAnimations from './animations/textAnimations';

// Animations
import './helpers/conversions-api';
import './global/changeScreen';
import './global/signupForm';

// Import main scss file here. This will compile to a css file in the dist folder
import '../scss/style.scss';

function init() {
	// Run text animations for the default page
	runTextAnimations('intro');
	runTextAnimations('scratchcard');
}

init();
